<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.sign_list' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCloseDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <span class="mt-3 mat-panel-title">{{'messages.signing_progress' | translate}} {{processedPercent}}%</span>
  <mat-progress-bar mode="determinate" color="primary" [bufferValue]="100" [value]="processedPercent">
  </mat-progress-bar>
  <mat-table [dataSource]="dataSource" class="mt-3">
    <!-- check -->
    <ng-container matColumnDef="check">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center check-col mat-cell-non-border-right-bottom">
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="mat-header-cell-center check-col mat-cell-non-border-right-bottom"
        (click)="$event.stopPropagation()">
        <!-- Đã ký -->
        <div *ngIf="element.status === 1;">
          <mat-icon style="color: #64c864" matTooltip="{{'messages.sign_sucess' | translate}}">check_circle</mat-icon>
        </div>

        <!-- Chưa ký -->
        <div *ngIf="element.status === 0;">
          <mat-icon>autorenew</mat-icon>
        </div>

        <!-- Lỗi -->
        <div *ngIf="element.status === -1;">
          <mat-icon color="accent" matTooltip="{{ element.description }}">error</mat-icon>
        </div>
      </mat-cell>
    </ng-container>
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-border-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index"
        class="mat-header-cell-center no-col mat-cell-non-border-right-bottom" (click)="$event.stopPropagation()">
        {{i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="max-width: 20%" class="mat-cell-non-border-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 20%" matTooltip="{{ element.contractName }}"
        class="mat-cell-non-border-right-bottom" (click)="$event.stopPropagation()">
        <span class="fix-width">{{element.contractName}}</span>
      </mat-cell>
    </ng-container>

    <!-- Tên các bên ký kết Column -->
    <ng-container matColumnDef="allName">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom">
        {{'headertable.contract_parties' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}" class="mat-cell-non-border-right-bottom"
        (click)="$event.stopPropagation()">
        <span class="fix-width">{{ element.allName}}</span>
      </mat-cell>
    </ng-container>

    <!-- Người chuyển Column -->
    <ng-container matColumnDef="createdUser">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom" style="max-width: 18%;">
        {{'enterprise_contract.table_headers.forward_by' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.createdUser }}" style="max-width: 18%;"
        (click)="$event.stopPropagation()" class="mat-cell-non-border-right-bottom">
        <span class="fix-width">{{ element.createdUser}}</span>
      </mat-cell>
    </ng-container>

    <!-- Ngày nhận -->
    <ng-container matColumnDef="receivedTime">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom"
        style="max-width: 12%;">{{'headertable.received_time' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.receivedTime | dateformat }}"
        class="mat-cell-non-border-right-bottom number-cell-center" (click)="$event.stopPropagation()"
        style="max-width: 12%;">
        <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
    </mat-row>
  </mat-table>
</mat-dialog-content>
<mat-divider class="mt-3"></mat-divider>
<mat-dialog-actions align="center">
  <!-- đóng popup -->
  <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCloseDialog()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.close' | translate}}
  </button>

  <!-- dừng ký -->
  <button mat-stroked-button color="primary" class="mr-3" (click)="onClickStopSign()" type="button"
    [disabled]="isDisabledStopSignButton">
    <mat-icon class="mr-0">block</mat-icon>
    {{'button.stop_sign' | translate}}
  </button>
</mat-dialog-actions>